<template>
  <v-app class="flex flex-column flex-auto">
    <!-- <SidebarMenu v-if="$mq.md" /> -->

    <Topbar :routePath="$route.path">
      <v-fab-transition appear>
        <router-view v-if="!readOnlyUser" name="speeddial" />
      </v-fab-transition>
    </Topbar>

    <SlideSidebarMenu/>
 
    <!-- <Sticky v-if="!$mq.md" top="0" style="z-index: 2 !important; margin-bottom: -56px;">
      <TopbarMenu  class="bg-white" />
      <v-divider />
    </Sticky> -->

    <NotificationSnackbar />

    <!-- conditionally set padding for mq.md (as determined by sidebar or not)
         style="padding-top: 5px;" When top menu then need more padding -->
 
    <v-content class="flex flex-column flex-auto" :style="$mq.md ? '' : 'padding-top: 5px;'">
      <v-divider v-if="$mq.md" />
      <v-container fluid class="flex flex-column flex-auto" :class="$mq.md_sm ? 'p3' : 'p2' ">
        <route-transition>
          <router-view />
        </route-transition>
      </v-container>
      <v-layout v-if="!$mq.md_sm" justify-center items-center class="circuit-background">
        <LogoMultitech white style="width: 100px" />
      </v-layout>
    </v-content>

  </v-app>
</template>


<script>
/* @flow */
import Sticky from 'vue-sticky-position'
import LogoMultitech from '@/components/LogoMultitech'

import RouteTransition from '@/components/RouteTransition'
import Topbar from '@/components/Topbar'
// import SidebarMenu from '@/components/SidebarMenu'
import SlideSidebarMenu from '@/components/SlideSidebarMenu'

import TopbarMenu from '@/components/TopbarMenu'
import NotificationSnackbar from '@/components/NotificationSnackbar'

import {FETCH_DEVICE_PROFILES} from '@/store/device_profiles'
import {FETCH_NETWORK_PROFILES} from '@/store/network_profiles'
import {FETCH_APPLICATION_NETWORKS} from '@/store/application_networks'
import {FETCH_CURRENT_USER} from '@/store/users'
import {orgAdmin, sysAdmin, readOnlyUser} from '@/utils/api'

export default {
  name: 'App',
  extends: {
    computed: {
      sysAdmin,
      orgAdmin,
      readOnlyUser,
    },
  },
  mounted() {
    // Always load these since almost every page needs it
    this.$store.dispatch(FETCH_APPLICATION_NETWORKS, {})
    this.$store.dispatch(FETCH_CURRENT_USER)
    this.$store.dispatch(FETCH_DEVICE_PROFILES)
    this.$store.dispatch(FETCH_NETWORK_PROFILES)
  },
  computed: {
    readOnlyUser,
  },
  components: {
    RouteTransition,
    Sticky,
    Topbar,
    // SidebarMenu,
    SlideSidebarMenu,
    TopbarMenu,
    NotificationSnackbar,
    LogoMultitech,
  },
}
</script>


<style>
  select.ag-filter-select{
    display:none;
  }
/*  div.ag-menu{
    margin-left: -11%;
  }
*/  input.ag-filter-filter{
    margin-top:8px;
    padding-top:5px;
  }
</style>

<style scoped>
.divider {
  flex: none;
}
.sys_admin.role {
  color: red;
  background-color: green;
}

.circuit-background {
  background: url('./assets/img/circuit-board-background.png');
  background-position: 0 -35px;
  height: 32px;
  max-height: 32px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue